import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { currentUserSelector } from '../AuthSelector';

const byUserId = content => content.get('userId');
const byMetadataId = content => content.get('metadataId');
const byId = content => content.get('id');

const getUGCByTypeFromState = ugcType => state => state.getIn(['entities', 'ugc', ugcType], Immutable.Map());

/*
 * Exports
 */
export const getUGCByType = ugcType =>
  createSelector(
    [getUGCByTypeFromState(ugcType)],
    ugc => ugc
  );

export const getUGCListByUsers = ugcType =>
  createSelector(
    [getUGCByType(ugcType)],
    ugc =>
      ugc.groupBy(byUserId).map(groupedUGC =>
        groupedUGC
          .toList()
          .sortBy(byId)
          .groupBy(byMetadataId)
      )
  );

export const getSingularUGCByUsers = ugcType =>
  createSelector(
    [getUGCListByUsers(ugcType)],
    ugcListByUser => ugcListByUser.map(ugcListByMetadataId => ugcListByMetadataId.map(ugcList => ugcList.first()))
  );

export const getUGCByBibs = ugcType =>
  createSelector(
    [getUGCByType(ugcType)],
    ugc => ugc.groupBy(byMetadataId).map(groupedUGC => groupedUGC.toList().sortBy(byId))
  );

export const getUGCListForCurrentUser = ugcType =>
  createSelector(
    [getUGCListByUsers(ugcType), currentUserSelector],
    (ugc, user) => (user && user.get('id') ? ugc.get(user.get('id'), Immutable.Map()) : Immutable.Map())
  );

export const getSingularUGCForCurrentUser = ugcType =>
  createSelector(
    [getSingularUGCByUsers(ugcType), currentUserSelector],
    (ugc, user) => (user && user.get('id') ? ugc.get(user.get('id'), Immutable.Map()) : Immutable.Map())
  );

export default {
  getUGCByType,
  getUGCListByUsers,
  getUGCByBibs,
  getUGCListForCurrentUser
};
